window.styles = [
  {
    name: 'style1',
    description: 'Single rectangle',
    layout: [
      {
        x: 0,
        y: 0,
        width: 1,
        height: 1,
        text: 'A',
        id: 'A',
        controllers: { opener: 'fixed' },
      },
    ],
  },
  {
    name: 'style2',
    description: 'Top small, bottom large',
    layout: [
      {
        x: 0,
        y: 0,
        width: 1,
        height: 0.25,
        text: 'A',
        id: 'A',
        defaultHeightMM: 400,
        totalCols: 1,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: null,
          height: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 1,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 1,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A'], // Bidirectional: B can also control A's height
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
    ],
  },
  {
    name: 'style3',
    description: 'Two equal vertical sections',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.5,
        height: 1,
        text: 'A',
        id: 'A',
        totalCols: 2,
        totalRows: 1,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.5,
        height: 1,
        text: 'B',
        id: 'B',
        totalCols: 2,
        totalRows: 1,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A'], // Bidirectional: B can also control A's width
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
    ],
  },
  {
    name: 'style4',
    description: 'Left small, right large',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.5,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 2,
        defaultHeightMM: 400,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['C'],
          height: ['B'],
          attachedWidth: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.5,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 2,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A'], // Bidirectional: B can also control A's height
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.5,
        height: 1,
        text: 'C',
        id: 'C',
        totalCols: 2,
        totalRows: 1,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A'], // Bidirectional: C can also control A's width
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
    ],
  },
  {
    name: 'style5',
    description: 'Left large, right column (top small, bottom large)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.75,
        height: 1,
        text: 'A',
        id: 'A',
        totalCols: 2,
        totalRows: 1,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.75,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'B',
        id: 'B',
        defaultHeightMM: 400,
        totalCols: 2,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A'], // Bidirectional: B can also control A's width
          height: ['C'],
          attachedWidth: ['C'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.75,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'C',
        id: 'C',
        totalCols: 2,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          height: ['B'], // Bidirectional: C can also control B's height
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style6',
    description: 'Top large, bottom row (left small, right large)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.5,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 2,
        totalRows: 2,
        defaultHeightMM: 400,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          height: ['C'],
          width: ['B'],
          attachedHeight: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.5,
        height: 0.25,
        text: 'B',
        id: 'B',
        totalCols: 2,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A'], // Bidirectional: B can also control A's width
          opener: 'fixed',
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 1,
        height: 0.75,
        text: 'C',
        id: 'C',
        totalCols: 1,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A'], // Bidirectional: C can also control A's height
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style7',
    description: 'Top row (2 equal), bottom large',
    layout: [
      {
        x: 0,
        y: 0,
        width: 1,
        height: 0.25,
        text: 'A',
        id: 'A',
        defaultHeightMM: 400,
        totalCols: 1,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          height: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.5,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 2,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          width: ['C'],
          attachedHeight: ['C'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.5,
        y: 0.25,
        width: 0.5,
        height: 0.75,
        text: 'C',
        id: 'C',
        totalCols: 2,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          width: ['B'], // Bidirectional: C can also control B's width
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style8',
    description: 'Left column (top small, bottom large), right large',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.5,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 2,
        totalRows: 2,
        colIndex: 0,
        defaultHeightMM: 400,
        rowIndex: 0,
        controllers: {
          height: ['B'],
          width: ['C'],
          attachedWidth: ['B'],
          attachedHeight: ['C'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.5,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 2,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A'], // Bidirectional: B can also control A's height
          attachedHeight: ['D'],
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.5,
        height: 0.25,
        text: 'C',
        id: 'C',
        totalCols: 2,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A'], // Bidirectional: C can also control A's width
          attachedWidth: ['D'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.5,
        y: 0.25,
        width: 0.5,
        height: 0.75,
        text: 'D',
        id: 'D',
        totalCols: 2,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style9',
    description: 'Four equal horizontal sections',
    layout: [
      {
        x: 0,
        y: 0,
        width: 1,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 1,
        totalRows: 4,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          height: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 1,
        height: 0.25,
        text: 'B',
        id: 'B',
        totalCols: 1,
        totalRows: 4,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A', 'C'], // Bidirectional: B can control both A and C
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.5,
        width: 1,
        height: 0.25,
        text: 'C',
        id: 'C',
        totalCols: 1,
        totalRows: 4,
        colIndex: 0,
        rowIndex: 2,
        controllers: {
          height: ['B', 'D'], // Bidirectional: C can control both B and D
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.75,
        width: 1,
        height: 0.25,
        text: 'D',
        id: 'D',
        totalCols: 1,
        totalRows: 4,
        colIndex: 0,
        rowIndex: 3,
        controllers: {
          height: ['C'], // Bidirectional: D can also control C's height
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
    ],
  },
  {
    name: 'style10',
    description: 'Three equal vertical sections',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.33,
        height: 1,
        text: 'A',
        id: 'A',
        totalCols: 3,
        totalRows: 1,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.33,
        y: 0,
        width: 0.34,
        height: 1,
        text: 'B',
        id: 'B',
        totalCols: 3,
        totalRows: 1,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'C'], // Bidirectional: B can control both A and C
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.67,
        y: 0,
        width: 0.33,
        height: 1,
        text: 'C',
        id: 'C',
        totalCols: 3,
        totalRows: 1,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['B'], // Bidirectional: C can also control B's width
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style11',
    description: 'Left tall, middle column (small top, large bottom), right tall',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.33,
        height: 1,
        text: 'A',
        id: 'A',
        totalCols: 3,
        totalRows: 2,
        rowSpan: 1,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.33,
        y: 0,
        width: 0.34,
        height: 0.25,
        text: 'B',
        id: 'B',
        defaultHeightMM: 400,
        totalCols: 3,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          height: ['C'],
          attachedWidth: ['C'],
          width: ['A'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.33,
        y: 0.25,
        width: 0.34,
        height: 0.75,
        text: 'C',
        id: 'C',
        totalCols: 3,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          height: ['B'], // Bidirectional: C can also control B's height
          opener: 'fixed',
        },
      },
      {
        x: 0.67,
        y: 0,
        width: 0.33,
        height: 1,
        text: 'D',
        id: 'D',
        totalCols: 3,
        totalRows: 2,
        rowSpan: 1,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['B'], // Bidirectional: D can also control B's width
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style12',
    description: 'Left tall, middle tall, right column (top small, bottom large)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.34,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 3,
        defaultHeightMM: 400,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['C'],
          attachedWidth: ['B'],
          height: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.34,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 3,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A'], // Bidirectional: B can also control A's height
          opener: 'fixed',
        },
      },
      {
        x: 0.34,
        y: 0,
        width: 0.33,
        height: 1,
        text: 'C',
        id: 'C',
        totalCols: 3,
        totalRows: 2,
        colIndex: 1,
        rowSpan: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'D'], // Bidirectional: C can control both A and D
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.67,
        y: 0,
        width: 0.33,
        height: 1,
        text: 'D',
        id: 'D',
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowSpan: 1,
        rowIndex: 0,
        controllers: {
          width: ['C'], // Bidirectional: D can also control C's width
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style13',
    description: 'Left large, right column (top small, middle small, bottom large)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.33,
        height: 1,
        text: 'A',
        id: 'A',
        totalCols: 3,
        totalRows: 2,
        rowSpan: 1,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.33,
        y: 0,
        width: 0.34,
        height: 1,
        text: 'B',
        id: 'B',
        totalCols: 3,
        totalRows: 2,
        rowSpan: 1,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'C'], // Bidirectional: B can control both A and C
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.67,
        y: 0,
        width: 0.33,
        height: 0.25,
        text: 'C',
        id: 'C',
        defaultHeightMM: 400,
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['B'], // Bidirectional: C can also control B's width
          height: ['D'],
          attachedWidth: ['D'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.67,
        y: 0.25,
        width: 0.33,
        height: 0.75,
        text: 'D',
        id: 'D',
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 1,
        controllers: {
          height: ['C'], // Bidirectional: D can also control C's height
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style14',
    description: 'Left column (top small, bottom large), middle tall, right column (top small, bottom large)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 3,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        defaultHeightMM: 400,
        controllers: {
          height: ['B'],
          width: ['C'],
          attachedWidth: ['B'],
          attachedHeight: ['D'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 3,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A'], // Bidirectional: B can also control A's height
          attachedHeight: ['E'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0,
        width: 0.5,
        height: 1,
        text: 'C',
        id: 'C',
        totalCols: 3,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        rowSpan: 1,
        controllers: {
          width: ['A', 'D'], // Bidirectional: C can control both A and D
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.75,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'D',
        id: 'D',
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['C'], // Bidirectional: D can also control C's width
          attachedWidth: ['E'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.75,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'E',
        id: 'E',
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style15',
    description: 'Left column (top small, middle small, bottom large), right large',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.34,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 3,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        defaultHeightMM: 400,
        controllers: {
          height: ['B'],
          width: ['C'],
          attachedWidth: ['B'],
          attachedHeight: ['C', 'E'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.34,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 3,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
          attachedHeight: ['D', 'F'],
        },
      },
      {
        x: 0.34,
        y: 0,
        width: 0.33,
        height: 0.25,
        text: 'C',
        id: 'C',
        totalCols: 3,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          attachedWidth: ['D'],
          width: ['E'],
          opener: 'fixed', // "fixed" | "top-opener" | "left-opener" | "right-opener" | "dummy"
        },
      },
      {
        x: 0.34,
        y: 0.25,
        width: 0.33,
        height: 0.75,
        text: 'D',
        id: 'D',
        totalCols: 3,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
      {
        x: 0.67,
        y: 0,
        width: 0.33,
        height: 0.25,
        text: 'E',
        id: 'E',
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['C'],
          attachedWidth: ['F'],
          opener: 'fixed',
        },
      },
      {
        x: 0.67,
        y: 0.25,
        width: 0.33,
        height: 0.75,
        text: 'F',
        id: 'F',
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style16',
    description: 'Top large, bottom row (3 equal)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 1,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 1,
        defaultHeightMM: 400,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          height: ['B'],
          opener: 'fixed',
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.33,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 3,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          width: ['C'],
          height: ['A'], // Bidirectional: B can also control A's height
          attachedHeight: ['C', 'D'],
          opener: 'fixed',
        },
      },
      {
        x: 0.33,
        y: 0.25,
        width: 0.34,
        height: 0.75,
        text: 'C',
        id: 'C',
        totalCols: 3,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          width: ['B', 'D'], // Bidirectional: C can control both B and D
          opener: 'fixed',
        },
      },
      {
        x: 0.67,
        y: 0.25,
        width: 0.33,
        height: 0.75,
        text: 'D',
        id: 'D',
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 1,
        controllers: {
          width: ['C'], // Bidirectional: D can also control C's width
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style17',
    description: 'Top row (3 equal), bottom large',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.33,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 3,
        totalRows: 2,
        colIndex: 0,
        defaultHeightMM: 400,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          height: ['D'],
          attachedHeight: ['B', 'C'],
          opener: 'fixed',
        },
      },
      {
        x: 0.33,
        y: 0,
        width: 0.34,
        height: 0.25,
        text: 'B',
        id: 'B',
        totalCols: 3,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'C'], // Bidirectional: B can control both A and C
          opener: 'fixed',
        },
      },
      {
        x: 0.67,
        y: 0,
        width: 0.33,
        height: 0.25,
        text: 'C',
        id: 'C',
        totalCols: 3,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['B'], // Bidirectional: C can also control B's width
          opener: 'fixed',
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 1,
        height: 0.75,
        text: 'D',
        id: 'D',
        totalCols: 1,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A'], // Bidirectional: D can also control A's height
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style18',
    description: 'Four equal quadrants',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'A',
        id: 'A',
        totalCols: 4,
        totalRows: 1,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'B',
        id: 'B',
        totalCols: 4,
        totalRows: 1,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'C'], // Bidirectional: B can control both A and C
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'C',
        id: 'C',
        totalCols: 4,
        totalRows: 1,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['B', 'D'], // Bidirectional: C can control both B and D
          opener: 'fixed',
        },
      },
      {
        x: 0.75,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'D',
        id: 'D',
        totalCols: 4,
        totalRows: 1,
        colIndex: 3,
        rowIndex: 0,
        controllers: {
          width: ['C'], // Bidirectional: D can also control C's width
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style19',
    description: 'Left column (small top, large bottom), middle tall, right column (small top, large bottom)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 4,
        totalRows: 2,
        defaultHeightMM: 400,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          height: ['B'],
          width: ['C'],
          attachedWidth: ['B'],
          attachedHeight: ['E'],
          opener: 'fixed',
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 4,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          height: ['A'], // Bidirectional: B can also control A's height
          attachedHeight: ['F'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'C',
        id: 'C',
        totalCols: 4,
        totalRows: 2,
        colIndex: 1,
        rowSpan: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'D'], // Bidirectional: C can control both A and D
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'D',
        id: 'D',
        totalCols: 4,
        totalRows: 2,
        colIndex: 2,
        rowSpan: 1,
        rowIndex: 0,
        controllers: {
          width: ['C', 'E'], // Bidirectional: D can control both C and E
          opener: 'fixed',
        },
      },
      {
        x: 0.75,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'E',
        id: 'E',
        totalCols: 4,
        totalRows: 2,
        colIndex: 3,
        rowIndex: 0,
        controllers: {
          width: ['D'], // Bidirectional: E can also control D's width
          attachedWidth: ['F'],
          opener: 'fixed',
        },
      },
      {
        x: 0.75,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'F',
        id: 'F',
        totalCols: 4,
        totalRows: 2,
        colIndex: 3,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style20',
    description: 'Left tall, middle column (small top, large bottom), right column (2 equal)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'A',
        id: 'A',
        totalCols: 4,
        totalRows: 2,
        colIndex: 0,
        rowSpan: 1,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'B',
        id: 'B',
        totalCols: 4,
        totalRows: 2,
        defaultHeightMM: 400,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'D'], // Bidirectional: B can control both A and D
          height: ['C'],
          attachedWidth: ['C'],
          attachedHeight: ['D'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'C',
        id: 'C',
        totalCols: 4,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          height: ['B'], // Bidirectional: C can also control B's height
          attachedHeight: ['E'],
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'D',
        id: 'D',
        totalCols: 4,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['B', 'F'], // Bidirectional: D can control both B and F
          attachedWidth: ['E'],
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'E',
        id: 'E',
        totalCols: 4,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
      {
        x: 0.75,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'F',
        id: 'F',
        totalCols: 4,
        totalRows: 2,
        colIndex: 3,
        rowSpan: 1,
        rowIndex: 0,
        controllers: {
          width: ['D'], // Bidirectional: F can also control D's width
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style21',
    description: 'Left tall, middle area (top small, bottom large), right tall',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'A',
        id: 'A',
        totalCols: 4,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        rowSpan: 1,
        controllers: {
          width: ['B'],
          checkWidth: ['D'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'B',
        id: 'B',
        totalCols: 4,
        defaultHeightMM: 400,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'C'], // Bidirectional: B can control both A and C
          height: ['D'],
          attachedHeight: ['C'],
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'C',
        id: 'C',
        totalCols: 4,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['B', 'E'], // Bidirectional: C can control both B and E
          checkWidth: ['D'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0.25,
        width: 0.5,
        height: 0.75,
        text: 'D',
        id: 'D',
        totalCols: 4,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        colSpan: 1,
        controllers: {
          height: ['B'], // Bidirectional: D can also control B's height
          combinedWidth: ['B', 'C'],
          opener: 'fixed',
        },
      },
      {
        x: 0.75,
        y: 0,
        width: 0.25,
        height: 1,
        text: 'E',
        id: 'E',
        totalCols: 4,
        totalRows: 2,
        colIndex: 3,
        rowIndex: 0,
        rowSpan: 1,
        controllers: {
          width: ['C'], // Bidirectional: E can also control C's width
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style22',
    description: 'Top row (3 equal), bottom row (2 equal)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 4,
        totalRows: 2,

        defaultHeightMM: 400,
        colIndex: 0,
        rowIndex: 0,
        controllers: {
          width: ['B'],
          height: ['E'],
          attachedHeight: ['B', 'C', 'D'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'B',
        id: 'B',
        totalCols: 4,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['A', 'C'], // Bidirectional: B can control both A and C
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'C',
        id: 'C',
        totalCols: 4,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['B', 'D'], // Bidirectional: C can control both B and D
          opener: 'fixed',
        },
      },
      {
        x: 0.75,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'D',
        id: 'D',
        totalCols: 4,
        totalRows: 2,
        colIndex: 3,
        rowIndex: 0,
        controllers: {
          width: ['C'], // Bidirectional: D can also control C's width
          opener: 'fixed',
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.5,
        height: 0.75,
        text: 'E',
        id: 'E',
        totalCols: 2,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          combinedWidth: ['A', 'B'],
          height: ['A'],
          attachedHeight: ['F'],
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0.25,
        width: 0.5,
        height: 0.75,
        text: 'F',
        id: 'F',
        totalCols: 2,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          combinedWidth: ['C', 'D'],
          opener: 'fixed',
        },
      },
    ],
  },
  {
    name: 'style23',
    description: 'Top row (2 equal), bottom row (3 equal)',
    layout: [
      {
        x: 0,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'A',
        id: 'A',
        totalCols: 4,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 0,
        defaultHeightMM: 400,
        controllers: {
          height: ['B'],
          width: ['C'],
          attachedWidth: ['B'],
          attachedHeight: ['C', 'E', 'G'],
          opener: 'fixed',
        },
      },
      {
        x: 0,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'B',
        id: 'B',
        totalCols: 4,
        totalRows: 2,
        colIndex: 0,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
          height: ['A'],
          attachedHeight: ['D', 'F', 'H'],
        },
      },
      {
        x: 0.25,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'C',
        id: 'C',
        totalCols: 4,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 0,
        controllers: {
          width: ['E'],
          attachedWidth: ['D'],
          opener: 'fixed',
        },
      },
      {
        x: 0.25,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'D',
        id: 'D',
        totalCols: 4,
        totalRows: 2,
        colIndex: 1,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'E',
        id: 'E',
        totalCols: 4,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 0,
        controllers: {
          width: ['G'],
          attachedWidth: ['F'],
          opener: 'fixed',
        },
      },
      {
        x: 0.5,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'F',
        id: 'F',
        totalCols: 4,
        totalRows: 2,
        colIndex: 2,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
      {
        x: 0.75,
        y: 0,
        width: 0.25,
        height: 0.25,
        text: 'G',
        id: 'G',
        totalCols: 4,
        totalRows: 2,
        colIndex: 3,
        rowIndex: 0,
        controllers: {
          attachedWidth: ['H'],
          width: ['E'],
          opener: 'fixed',
        },
      },
      {
        x: 0.75,
        y: 0.25,
        width: 0.25,
        height: 0.75,
        text: 'H',
        id: 'H',
        totalCols: 4,
        totalRows: 2,
        colIndex: 3,
        rowIndex: 1,
        controllers: {
          opener: 'fixed',
        },
      },
    ],
  },
];
